import API from '@/api';
import { isSameOrAfter } from '@/utils/dateHelpers.js';

const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
const GET_TRANSACTIONS_FAILED = 'GET_TRANSACTIONS_FAILED';

// Enabled the module to be namespaced
const namespaced = true;

// Products initial state
const state = {
  loading: false,
  transactions: [],
};

const emptyState = {
  loading: false,
  transactions: [],
};

// Products getters
const getters = {
  show: (state) => {
    return state.transactions;
  },
};

// Transaction actions
const actions = {
  // * show fetches a list TRANSACTIONS for a license from the API
  async show({ commit }, payload) {
    let response;

    commit(GET_TRANSACTIONS);

    try {
      response = await API.transactions.show(payload);

      if (response?.status >= 400 || response?.data === 'Network Error' || !response?.data) {
        response.data = [];
      }

      response.data = response.data?.map((transaction) => {
        if (transaction?.originalTransactionID?.includes('trugolf_admin')) {
          transaction.adminRedeemed = true;
        }
        if (transaction?.originalTransactionID?.startsWith('c_')) {
          transaction.conversionProduct = true;
        }
        const isActive = isSameOrAfter(transaction?.expirationDate, new Date().toISOString());

        //* Should this check for subscription status as well?
        // const isActive =
        //   isSameOrAfter(transaction?.expirationDate, new Date().toISOString()) ||
        //   transaction.subscriptionStatus === 'active';
        transaction.isActive = isActive;
        return transaction;
      });

      //* Returning all product and subscription data in api call now - no longer needed
      // response.data = await Promise.all(
      //   response?.data?.map(async (transaction) => {
      //     let subscriptionDetails = {};
      //     if (transaction?.originalTransactionID?.includes('sub_')) {
      //       subscriptionDetails = await API.shop.getSubscription(transaction.originalTransactionID);
      //     }
      //     if (transaction?.originalTransactionID?.includes('trugolf_admin')) {
      //       transaction.adminRedeemed = true;
      //     }

      //     const productDetails = await API.shop.show(transaction.productID);
      //     if (productDetails?.data) {
      //       return {
      //         subscriptionDetails:
      //           Object.keys(subscriptionDetails).length > 0 ? subscriptionDetails.data : {},
      //         ...transaction,
      //         ...productDetails.data,
      //       };
      //     }
      //     return transaction;
      //   })
      // );
    } catch (err) {
      response = err;
    }

    //* Current not getting to this point if I return above
    return new Promise((resolve, reject) => {
      // console.log('response:', response);
      if (!response.data || response.status >= 400) {
        commit(GET_TRANSACTIONS_FAILED);
        reject(response);
      } else {
        resolve(response.data);
        commit(GET_TRANSACTIONS_SUCCESS, response.data);
        return response;
        // * Return GET data with promise
      }
    });
  },
};

// Transaction mutations
const mutations = {
  [GET_TRANSACTIONS](state) {
    state.loading = true;
  },

  [GET_TRANSACTIONS_SUCCESS](state, transactions) {
    state.transactions = transactions;
    state.loading = false;
  },

  [GET_TRANSACTIONS_FAILED](state) {
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
